import { Box, Link, Paper, Stack, Typography } from "@mui/material";

// Logo jest w public/assets/, więc używamy ścieżki bezwzględnej
const FlexLogo = "/assets/Logo - Flex System_SVG.svg";

interface FlexBannerProps {
  variant?: "login" | "dashboard";
}

const FLEX_LP_URL = "https://flex-system-omega.vercel.app/?utm_source=skrutiner&utm_medium=internal_banner&utm_campaign=flex_awareness";

export default function FlexBanner({ variant = "login" }: FlexBannerProps) {
  if (variant === "login") {
    return (
      <Box
        sx={{
          mt: 3,
          p: 2,
          backgroundColor: "#f8f9fa",
          borderRadius: 1,
          border: "1px solid #e9ecef",
        }}
      >
        <Stack 
          direction={{ xs: "column", sm: "row" }} 
          spacing={2} 
          alignItems={{ xs: "center", sm: "center" }}
        >
          <Box
            component="img"
            src={FlexLogo}
            alt="Flex System"
            sx={{
              height: { xs: 50, sm: 60 },
              maxWidth: "100%",
              flexShrink: 0,
            }}
          />
          <Box sx={{ flex: 1, textAlign: { xs: "center", sm: "left" } }}>
            <Typography
              variant="body2"
              sx={{
                fontSize: "0.875rem",
                color: "#495057",
                mb: 0.5,
                fontWeight: 500,
              }}
            >
              Prowadzisz szkołę tańca?
            </Typography>
            <Typography
              variant="body2"
              sx={{
                fontSize: "0.8rem",
                color: "#6c757d",
                mb: 1,
              }}
            >
              Flex to system, który pomaga ogarnąć grafik, kursantów i płatności.
            </Typography>
            <Link
              href={FLEX_LP_URL}
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                fontSize: "0.875rem",
                color: "#6366f1",
                textDecoration: "none",
                "&:hover": {
                  textDecoration: "underline",
                },
              }}
            >
              Dowiedz się więcej →
            </Link>
          </Box>
        </Stack>
      </Box>
    );
  }

  // Wariant dashboard - opakowany w Paper dla lepszej widoczności
  return (
    <Paper
      elevation={0}
      sx={{
        mt: 4,
        p: 3,
        backgroundColor: "#f8f9fa",
        borderRadius: 1,
        border: "1px solid #e9ecef",
      }}
    >
      <Stack
        direction={{ xs: "column", sm: "row" }}
        spacing={2}
        alignItems={{ xs: "center", sm: "center" }}
        sx={{ flexWrap: "wrap" }}
      >
        <Box
          component="img"
          src={FlexLogo}
          alt="Flex System"
          sx={{
            height: { xs: 40, sm: 48 },
            maxWidth: "100%",
            flexShrink: 0,
          }}
        />
        <Typography
          variant="body2"
          sx={{
            fontSize: "0.875rem",
            color: "#495057",
            flex: 1,
            textAlign: { xs: "center", sm: "left" },
          }}
        >
          System Flex wspiera szkoły tańca w codziennej organizacji — zajęcia, uczestnicy, płatności.{" "}
          <Link
            href={FLEX_LP_URL}
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              color: "#6366f1",
              fontWeight: 500,
              textDecoration: "none",
              "&:hover": {
                textDecoration: "underline",
              },
            }}
          >
            Zobacz, jak działa
          </Link>
        </Typography>
      </Stack>
    </Paper>
  );
}

